<template>
  <BaseBlockRenderer v-bind="properties" />
</template>

<script lang="ts" setup>
import { provide } from 'vue'

import {
  BLOCK_RENDERER_PAGE_PARAMS_INJECTION_KEY,
  type BlockRendererProps,
} from '@backmarket/nuxt-layer-cms/BaseBlockRenderer.types'
import BaseBlockRenderer from '@backmarket/nuxt-layer-cms/BaseBlockRenderer.vue'

import { usePageParamsFromRoute } from '../../composables/usePageParamsFromRoute'

defineOptions({ inheritAttrs: false })

const properties = withDefaults(defineProps<BlockRendererProps>(), {
  withBottomMargin: true,
  hydrationMode: 'auto',
})

const pageParamsFromRoute = usePageParamsFromRoute()

provide(BLOCK_RENDERER_PAGE_PARAMS_INJECTION_KEY, pageParamsFromRoute)
</script>
